import { VirtualTableHeadCell } from '../../virtualized-table/types';
import { SelectColumnFilter } from '../filter';
import UpdateComment from '../update-comment';

export const preTableHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'make',
    Header: 'Asset Make',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'serialNumber',
    Header: 'Asset-SN',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'commercialType',
    Header: 'Comm Device Type',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'deviceType',
    Header: 'DeviceType',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'ecmSerialNumber',
    Header: 'ECM-SN',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'deviceId',
    Header: 'Device ID',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'deviceKey',
    Header: 'Device Key',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'reportedFirmware',
    Header: 'Current Software',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'configPartNumber',
    Header: 'Current Config PN',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'lastCheckInTime',
    Header: 'Last Checkin',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'description',
    Header: 'Description',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'preFlashComment',
    Header: 'Comments',
    component: UpdateComment,
  },
];

export const simCredentialingHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'make',
    Header: 'Asset Make',
  },
  {
    accessor: 'serialNumber',
    Header: 'Asset Serial Number',
  },
  {
    accessor: 'country',
    Header: 'Country',
  },
  {
    accessor: 'recredentialStatus',
    Header: 'Credential Status',
  },
  {
    accessor: 'description',
    Header: 'Credential Description',
  },
  {
    accessor: 'lastUpdatedTime',
    Header: 'Last Updated Time',
  },
];

export const engineeringTemplateHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'make',
    Header: 'Asset Make',
  },
  {
    accessor: 'serialNumber',
    Header: 'Asset Serial Number',
  },
  {
    accessor: 'country',
    Header: 'Country',
  },
  {
    accessor: 'lmno',
    Header: 'LMNO',
  },
  {
    accessor: 'recredentialStatus',
    Header: 'Credential Status',
  },
  {
    accessor: 'description',
    Header: 'Credential Description',
  },
  {
    accessor: 'lastUpdatedTime',
    Header: 'Last Updated Time',
  },
];


export const configAdminHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'applicationId',
    Header: 'Application Id'
  },
  {
    accessor: 'make',
    Header: 'Asset Make',
  },
  {
    accessor: 'serialNumber',
    Header: 'Asset Serial Number',
  },
  {
    accessor: 'modifiedBy',
    Header: 'Queued By',
  },
  {
    accessor: 'modifiedDateTime',
    Header: 'Last Date Modified',
  },
  {
    accessor: 'fileType',
    Header: 'File Type',
  },
  {
    accessor: 'statusMessage',
    Header: 'Status Message',
  },
];

export const postTableHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'make',
    Header: 'Asset Make',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'serialNumber',
    Header: 'Asset-SN',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'deviceId',
    Header: 'Device ID',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'deviceType',
    Header: 'Device Type',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'desiredFirmware',
    Header: 'Desired Software',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'configPartNumber',
    Header: 'Desired Config PN',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'lastCheckInTime',
    Header: 'Last Check-In',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'queued',
    Header: 'Queued',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'downloaded',
    Header: 'Downloaded',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'flashed',
    Header: 'Flashed',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'autoRetryFailed1',
    Header: 'Auto-Retry 1',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'autoRetryFailed2',
    Header: 'Auto-Retry 2',
  },
  {
    accessor: 'reportedSoftware',
    Header: 'Reported Software',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'inactivity',
    Header:'Removed Due To Inactivity',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'postFlashComment',
    Header: 'Comments',
    component: UpdateComment,
  },
];

export const modemOnlyFlashHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'deviceId',
    Header: 'Device ID',
  },
  {
    accessor: 'deviceKey',
    Header: 'Device Key',
  },
  {
    accessor: 'status',
    Header: 'Modem Updated Status',
  },
  {
    accessor: 'description',
    Header: 'Comments',
  },
];

export const scheduleCommandHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'deviceId',
    Header: 'Device Id',
  },
  {
    accessor: 'data',
    Header: 'Data',
  },
  {
    accessor: 'fileType',
    Header: 'File Type',
  },
  {
    accessor: 'frequency',
    Header: 'Frequency',
  },
  {
    accessor: 'updatedBy',
    Header: 'Last Updated By',
  }
];

export const preTableSortableAccessors = {
  make: true,
  serialNumber: true,
  commercialType: true,
  deviceType: true,
  ecmSerialNumber: true,
  deviceId: true,
  deviceKey: true,
  reportedFirmware: true,
  configPartNumber: true,
  lastCheckInTime: true,
  preFlashComment: true,
};

export const postTableSortableAccessors = {
  make: true,
  serialNumber: true,
  deviceId: true,
  deviceType: true,
  desiredFirmware: true,
  configPartNumber: true,
  lastCheckInTime: true,
  queued: true,
  downloaded: true,
  flashed: true,
  autoRetryFailed1: true,
  autoRetryFailed2: true,
  reportedSoftware: true,
  removedDueToInactivity: true,
  postFlashComment: true,
};

export const commandsTableSortableAccessors = {
  modifiedBy: true,
  modifiedDateTime: true,
  fileType: true,
  applicationId: true,
  make: true,
  serialNumber: true,
  deviceId: true,
  frequency: true,
  data: true,
  updatedBy: true,
};

export const flashModemOnlySortableAccessors = {
};